module.exports = __webpack_public_path__ + "img/icon-bank.06f38067.svg";